import React, { useRef, useState } from "react";

import CourseImage from "./CourseImageUpload";
import CourseVideo from "./CourseVideoUpload";
import CourseFile from "./CourseFileUpload";

function CreateCourseSection() {
  const [courseImage, setcourseImage] = useState([]);
  const [courseVideo, setcourseVideo] = useState([]);

  const courseImageFile = (content) => {
    if (content.length > 0) readImageFile(content[0]);
  };

  const courseVideoFile = (content) => {
    setcourseVideo(content);
  };

  const readImageFile = (file) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      setcourseImage(reader.result);
    };

    reader.readAsDataURL(file);
  };

  return (
    <div>
      <div className="createcourse">
        <div className="page-title">Create Course Section</div>
        <div className="form-group">
          <label htmlFor="CourseImage" className="mt-2">
            Course Section Image
          </label>
          <CourseImage
            courseImageFileLimit={1}
            courseImageFile={courseImageFile}
          />
        </div>

        <div className="form-group">
          <label htmlFor="CourseVideo" className="mt-2">
            Course Section Video
          </label>
          <CourseVideo
            courseVideoFileLimit={1}
            courseImage={courseImage}
            courseVideoFile={courseVideoFile}
          />
        </div>
        <div className="form-group">
          <label htmlFor="CourseFile" className="mt-2">
            Course Section File
          </label>
          <CourseFile courseFileLimit={5} />
        </div>
      </div>
    </div>
  );
}

export default CreateCourseSection;
